import React, {Fragment} from "react";
import FutureAbsenceFilterButton from "root/s360components/FutureAbsence/FutureAbsenceFilterButton";
import './FutureAbsencePage.scss';


export const FutureAbsenceFilterNames = {
    ALL: 'All',
    TODAY: 'Today',
    FUTURE: 'Future',
    PAST: 'Past',
}

const FutureAbsenceFilters = ({filter, setFilter}) =>
{

    const buttonClick = (filter) =>
    {
        setFilter(filter.target.id);
    }

    function buttonColor(filter, thisButton)
    {
        if (filter === thisButton)
        {
            return 'btn-primary';
        }
        else
        {
            return 'btn-secondary';
        }
    }

    const filterButtons = [
        {onClick: (filter) => buttonClick(filter), btnText: FutureAbsenceFilterNames.ALL, icon: "circle-plus", color: buttonColor(filter, FutureAbsenceFilterNames.ALL)},
        {onClick: (filter) => buttonClick(filter), btnText: FutureAbsenceFilterNames.TODAY, icon: "circle-plus", color: buttonColor(filter, FutureAbsenceFilterNames.TODAY)},
        {onClick: (filter) => buttonClick(filter), btnText: FutureAbsenceFilterNames.FUTURE, icon: "circle-plus", color: buttonColor(filter, FutureAbsenceFilterNames.FUTURE)},
        {onClick: (filter) => buttonClick(filter), btnText: FutureAbsenceFilterNames.PAST, icon: "circle-plus", color: buttonColor(filter, FutureAbsenceFilterNames.PAST)},
    ]

    return (
        <Fragment>
            {filterButtons.map((item, key) =>
            {
                return <FutureAbsenceFilterButton key={key} onClick={item.onClick} btnText={item.btnText} icon={item.icon} color={item.color}/>
            })}
        </Fragment>
    )
}

export default FutureAbsenceFilters;